/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingIdQueryResponse, GetApiBookingIdPathParams, GetApiBookingIdQueryParams } from "../entities/GetApiBookingId";

function getGetApiBookingIdUrl(id: GetApiBookingIdPathParams["id"]) {
  const res = { method: 'GET', url: `/api/booking/${id}` as const }
  return res
}

/**
 * @description Получить детали записи
 * @summary Получить запись по ID
 * {@link /api/booking/:id}
 */
export async function getApiBookingId(id: GetApiBookingIdPathParams["id"], params: GetApiBookingIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBookingIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiBookingIdUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}